import { type ReactNode } from "react";
import { Provider } from "react-redux";
import { store } from "../../store";

export const FlightsReduxProvider = ({ children }: { children: ReactNode }) => {
  return <Provider store={store}>{children}</Provider>;
};
